import React from 'react';
import { usePathname } from 'next/navigation';
import { NavItem } from '@/components/nav/Header';
import LinkLocalized from '@/components/nav/LinkLocalized';

type Props = {
  item: NavItem;
  callback: () => void;
};

export function BurgerMenuLink({ item, callback }: Props) {
  const selected = usePathname()?.includes(item.href);

  return (
    <LinkLocalized href={item.href}>
      <div
        onClick={callback}
        className={`py-2 px-5 text-xl font-bold transition-all duration-300  ${
          selected ? 'rounded-md bg-gray-100 dark:bg-gray-800' : ''
        }`}
      >
        <span className={`transition-all duration-500 ${selected ? '' : ''}`}>
          {item.icon}
        </span>
        <span className="ml-2">{item.label}</span>
      </div>
    </LinkLocalized>
  );
}
